import { OverlayRef } from "@angular/cdk/overlay";
import { Observable, Subject } from "rxjs";
import { filter, take } from "rxjs/operators";
import { CalendarRangePickerComponent } from "./calendar-range-picker.component";

export class CalendarRangePickerOverlayRef {
	private _beforeClose = new Subject<any>();
	private _afterClosed = new Subject<any>();

	componentInstance: CalendarRangePickerComponent;

	constructor(private overlayRef: OverlayRef) {}

	close<T>(data?: T): void {
		this.componentInstance.animationStateChanged
			.pipe(
				filter((event: any) => event.phaseName === "start"),
				take(1)
			)
			.subscribe(() => {
				this._beforeClose.next(data);
				this._beforeClose.complete();
				this.overlayRef.detachBackdrop();
			});

		this.componentInstance.animationStateChanged
			.pipe(
				filter((event: any) => event.phaseName === "done" && event.toState === "leave"),
				take(1)
			)
			.subscribe(() => {
				this.overlayRef.dispose();
				this._afterClosed.next(data);
				this._afterClosed.complete();

				this.componentInstance = null;
			});
		this.componentInstance.startExitAnimation();
	}

	afterClosed(): Observable<any> {
		return this._afterClosed.asObservable();
	}

	beforeClose(): Observable<any> {
		return this._beforeClose.asObservable();
	}
}
